module.exports = __webpack_public_path__ + "img/jiu4.14a6bb9b.png";